module.exports = __webpack_public_path__ + "static/media/mobile.81f09f26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mobile.svg
// module id = 162
// module chunks = 0